import { useForm } from "@mantine/form";
import { EventTypes, IEvent } from "../../../models/events";
import { useDrawerStore } from "../../../store/dashboard.store";
import { useEventStore } from "../../../store/events.store";
import { Button, NumberInput, Select } from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import dayjs from "dayjs";

const EditEvent = ({ event }: { event: IEvent }) => {
    const updateEvent = useEventStore(state => state.updateEvent);
    const popPage  = useDrawerStore(state => state.popPage);
    
    const form = useForm({
        initialValues: {
            type: event.type,
            date: dayjs(event.date).toDate(),
            limit: event.limit,
        },
        validate: {
            type: (value: string) => (value ? null : 'Type is required'),
            date: (value: Date) => (value ? null : 'Date is required'),
            limit: (value: number) => (value ? null : 'Limit is required'),
        },
    })
    return (
        <form onSubmit={form.onSubmit(async (values) => { 
            await updateEvent({ ...values, date: values.date.toISOString(), uid: event.uid }); 
            popPage();
        })}>
            <Select
                label="Type"
                required
                data={[EventTypes.GENERAL, EventTypes.BEHAVIOR]}
                {...form.getInputProps('type')}
            />
            <DateTimePicker
                label="Date"
                required
                valueFormat="MMM DD YYYY hh:mm a"
                {...form.getInputProps('date')}
            />
            <NumberInput
                label="Limit"
                required
                placeholder="10"
                {...form.getInputProps('limit')}
            />
            <br/>
            <Button type="submit">Update</Button>
        </form>
    );
};

export default EditEvent;